<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">

                <b-button block v-b-toggle.term-section-3
                class="text-left fw-500 d-flex align-items-center justify-content-between">
                    <div>
                        <span class="box-numbering">03</span>
                        <span>Card Use</span>    
                    </div>
                    <span 
                        class="toggle-icon" 
                        :class="{ active: isOpen }"
                    >
                        <span class="plus">+</span>
                        <span class="cross">×</span>
                    </span> 
                </b-button>
                
            </b-card-header>
            <b-collapse 
            id="term-section-3" 
            visible 
            accordion="my-accordion" 
            role="tabpanel"
            @show="isOpen = true"
            @hide="isOpen = false">
                <b-card-body>
                    <p class="text-justify">
                        <ol>
                            <li>Your {{ companyName }} card is a prepaid card that can be used to make payments wherever the card’s payment network is accepted.</li>
                            <li>You are responsible for keeping your card secure and for all transactions made using your card.</li>
                            <li>You must ensure that there are sufficient funds available on your card to cover your transactions.</li>
                            <li>The card may not be used for unlawful purposes, including illegal gambling or money laundering.</li>
                        </ol>  
                    </p>  
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>
</template>


<script>
export default {
    name: 'term-3',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        isOpen: true
        };
    },
    props:['companyName']
};
</script>